<template>
    <div class="add_product">
        <div style="display: flex; flex-direction: column; align-items: center; margin: 0px 0;">

            <div class="right_content">
                <div class="title">管理产品</div>
                <div class="right_list">
                    <span class="list_message">所属机构</span>
                    <Select v-model="right_form.organization_id" style="width:23%">
                        <Option v-for="item in organizationList" :value="item.value" :key="item.value">
							{{ item.label}}
                        </Option>
                    </Select>
                    <span class="list_message">产品名称</span>
                    <Input v-model="right_form.name" style="width:23%"/>
                    <span class="list_message">产品编号</span>
                    <Input v-model="right_form.product_number" style="width:23%"/>
                </div>
                <div class="right_list">
                    <span class="list_message">年化利率</span>
                    <Input v-model="right_form.year_rate" style="width:10%">
                        <span slot="append">%</span>
                    </Input>
                    <span class="list_message">产品类型</span>
                    <Select v-model="right_form.product_type" style="width:13%">
                        <Option v-for="item in product_type_list" :value="item.value" :key="item.value">
							{{item.label}}
                        </Option>
                    </Select>
                    <span class="list_message">还款期限</span>
                    <Input v-model="right_form.repayment_period" style="width:10%">
                        <span slot="append">月</span>
                    </Input>
                    <span class="list_message">放款额度：</span>
                    <span class="list_message list_message_color">最低</span>
                    <Input v-model="right_form.min_loan_money" style="width:10%">
                        <span slot="append">元</span>
                    </Input>
                    <span class="list_message list_message_color">最高</span>
                    <Input v-model="right_form.max_loan_money" style="width:10%">
                        <span slot="append">元</span>
                    </Input>
                </div>
                <div class="right_list">
                    <span class="list_message">地域</span>
                    <Cascader :data="dataCity" v-model="right_form.ext_info.city" style="width: 35%;"></Cascader>
                    <span class="list_message">市场状态</span>
                    <Select v-model="right_form.bazaar_state" style="width:10%">
                        <Option v-for="item in bazaar_state_list" :value="item.value" :key="item.value">
							{{ item.label}}
                        </Option>
                    </Select>

                    <span class="list_message">产品说明资料上传：</span>
                    <a v-if="right_form.ext_info.file" target="_blank" :href="right_form.ext_info.file" style="padding-right: 5px">点我查看</a>
                    <Button type="primary" @click="uploadFile">上传资料</Button>

                </div>
                <div class="right_list">
                    <span class="list_message">还款方式：</span>
                    <CheckboxGroup v-model="right_form.repayment_way">
                        <Checkbox label="1"><span>随借随还</span></Checkbox>
                        <Checkbox label="2"><span>等额本息</span></Checkbox>
                        <Checkbox label="3"><span>等额本金</span></Checkbox>
                        <Checkbox label="4"><span>先息后本</span></Checkbox>
                    </CheckboxGroup>
                </div>

                <div class="right_title">产品匹配设置</div>

                <CheckboxGroup v-model="rigth_data_list">
                    <div class="right_che_flex">
                        <div class="right_flex">
                            <Checkbox label="income"><span>收入</span></Checkbox>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.income">
                                    <Radio :label="1"><span>银行转账或代发工资最低</span></Radio>
                                    <Input v-model="condition.min_income" style="width:15%"/>
                                    <span class="list_message">元</span>
                                    <Radio :label="2"><span>银行代发工资(有扣税)最低</span></Radio>
                                    <Input v-model="condition.max_income" style="width:15%"/>
                                    <span class="list_message">元</span>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="age"><span>借款年龄</span></Checkbox>
                            <span class="list_message">借款人年龄最低</span>
                            <Input v-model="condition.minAge" style="width:100px">
                                <span slot="append">周岁</span>
                            </Input>
                            <span class="list_message">最高</span>
                            <Input v-model="condition.maxAge" style="width:100px">
                                <span slot="append">周岁</span>
                            </Input>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="work_time"><span>工作时间</span></Checkbox>
                            <span class="list_message">本单位连入职时间最低</span>
                            <Input v-model="condition.min_entry_time" style="width:140px">
                                <span slot="append">个月以上</span>
                            </Input>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="property_conditions"><span>房产条件</span></Checkbox>
                            <span class="list_message">房产位置</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.house_location">
                                    <Radio :label="1"><span>本地市区房</span></Radio>
                                    <Radio :label="2"><span>本地郊区</span></Radio>
                                    <Radio :label="3"><span>本省内房产</span></Radio>
                                    <Radio :label="0"><span>不限区域</span></Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="monthly_housing"><span>月供房</span></Checkbox>
                            <span class="list_message">最低月供金额</span>
                            <Input v-model="condition.monthly_sum" style="width:15%">
                                <span slot="append">元</span>
                            </Input>
                            <span class="list_message">最低月供时长</span>
                            <Input v-model="condition.monthly_duration" style="width:15%">
                                <span slot="append">个月</span>
                            </Input>
                            <span class="list_message">能否提供房产证</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.house_ID">
                                    <Radio :label="0"><span>不限</span></Radio>
                                    <Radio :label="1"><span>有房产证</span></Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="full_house"><span>全款房</span></Checkbox>
                            <span class="list_message">房产估值最低额度</span>
                            <Input v-model="condition.min_house_value" style="width:15%">
                                <span slot="append">元</span>
                            </Input>
                            <span class="list_message">房龄最高年限</span>
                            <Input v-model="condition.max_house_age" style="width:10%">
                                <span slot="append">年</span>
                            </Input>
                            <span class="list_message">房屋面积</span>
                            <Input v-model="condition.floor_space" style="width:15%">
                                <span slot="append">平米以上</span>
                            </Input>
                            <span class="list_message">能否提供房产证</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.whole_house_ID">
                                    <Radio :label="0"><span>不限</span></Radio>
                                    <Radio :label="1"><span>有房产证</span></Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="homestead"><span>自建房/宅基地</span></Checkbox>
                            <span class="list_message">土地证</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.land_deed">
                                    <Radio :label="1"><span>有</span></Radio>
                                    <Radio :label="0"><span>无</span></Radio>
                                </RadioGroup>
                            </div>
                            <span class="list_message">房产价值</span>
                            <Input v-model="condition.house_value" style="width:25%">
                                <span slot="append">以上</span>
                            </Input>
                            <span class="list_message">房屋面积</span>
                            <Input v-model="condition.land_deed_floor_space" style="width:20%">
                                <span slot="append">平米以上</span>
                            </Input>
                            <span class="list_message">村集体分红</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.receive_dividends">
                                    <Radio :label="1"><span>有</span></Radio>
                                    <Radio :label="0"><span>无</span></Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <div class="right_title" style="width: 170px;">车辆资产</div>
                            <span class="list_message">车牌注册城市范围</span>
                            <Cascader :data="dataCity" v-model="condition.plate_territory"
                                      style="width: 35%;"></Cascader>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="monthly_car_supply"><span>月供车</span></Checkbox>

                            <span class="list_message">月供金额</span>
                            <Input v-model="condition.car_monthly_sum" style="width:20%">
                                <span slot="append">以上</span>
                            </Input>
                            <span class="list_message">最低还款期数</span>
                            <Input v-model="condition.car_repayment_periods" style="width:10%">
                                <span slot="append">期</span>
                            </Input>

                        </div>
                        <div class="right_flex">
                            <Checkbox label="all_models"><span>全款车</span></Checkbox>

                            <span class="list_message">裸车价</span>
                            <Input v-model="condition.naked_car_sum" style="width:20%">
                                <span slot="append">元以下</span>
                            </Input>
                            <span class="list_message">车龄</span>
                            <Input v-model="condition.car_age" style="width:15%">
                                <span slot="append">年以下</span>
                            </Input>

                        </div>
                        <div class="right_flex">
                            <Checkbox label="accumulation_fund"><span>公积金</span></Checkbox>

                            <span class="list_message">公积金基数</span>
                            <Input v-model="condition.accumulation_fund" style="width:20%">
                                <span slot="append">以上</span>
                            </Input>
                            <span class="list_message">缴纳时长</span>
                            <Input v-model="condition.accumulation_fund_time" style="width:15%">
                                <span slot="append">个月以上</span>
                            </Input>
                            <span class="list_message"></span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.accumulation_fund_type" >
                                    <Radio :label="1"><span>本地公积金</span></Radio>
                                    <Radio :label="0"><span>不限</span></Radio>
                                </RadioGroup>
                            </div>

                        </div>
                        <div class="right_flex">
                            <Checkbox label="social_security"><span>社保</span></Checkbox>

                            <span class="list_message">社保基数</span>
                            <Input v-model="condition.social_security" style="width:20%">
                                <span slot="append">以上</span>
                            </Input>
                            <span class="list_message">缴纳时长</span>
                            <Input v-model="condition.social_security_time" style="width:15%">
                                <span slot="append">个月以上</span>
                            </Input>
                            <span class="list_message"></span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.social_security_type">
                                    <Radio :label="1"><span>本单位社保</span></Radio>
                                    <Radio :label="0"><span>不限</span></Radio>
                                </RadioGroup>
                            </div>

                        </div>
                        <div class="right_flex">
                            <Checkbox label="commercial_insurance"><span>商业保险</span></Checkbox>

                            <span class="list_message">年缴保费最低金额</span>
                            <Input v-model="condition.commercial_insurance_min_sum" style="width:12%">
                                <span slot="append">元</span>
                            </Input>
                            <span class="list_message">最低年缴次数</span>
                            <Input v-model="condition.commercial_insurance_min_number" style="width:10%">
                                <span slot="append">次</span>
                            </Input>
                            <span class="list_message">投保人</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.policy_holder">
                                    <Radio :label="1"><span>本人</span></Radio>
                                    <Radio :label="0"><span>不限</span></Radio>
                                </RadioGroup>
                            </div>
                            <span class="list_message">是否允许断缴</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.off_to_pay">
                                    <Radio :label="1"><span>是</span></Radio>
                                    <Radio :label="0"><span>否</span></Radio>
                                </RadioGroup>
                            </div>

                        </div>

                        <div class="right_flex">
                            <Checkbox label="micro_loan"><span>微粒贷</span></Checkbox>
                            <span class="list_message">授信额度</span>
                            <Input v-model="condition.weilidai_sum" style="width:20%">
                                <span slot="append">元以上</span>
                            </Input>
                            <span class="list_message">开通时间</span>
                            <Input v-model="condition.weilidai_time" style="width:20%">
                                <span slot="append">个月以上</span>
                            </Input>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="zm_credit_score"><span>芝麻信用分</span></Checkbox>
                            <span class="list_message">信用分</span>
                            <Input v-model="condition.zhima_number" style="width:20%">
                                <span slot="append">分以上</span>
                            </Input>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="number_of_credit_inquiry"><span>征信查询次数</span></Checkbox>
                            <span class="list_message">近1个月查询</span>
                            <Input v-model="condition.credit_one_month" style="width:8%">
                                <span slot="append">次</span>
                            </Input>
                            <span class="list_message">近2个月查询</span>
                            <Input v-model="condition.credit_two_month" style="width:8%">
                                <span slot="append">次</span>
                            </Input>
                            <span class="list_message">近3个月查询</span>
                            <Input v-model="condition.credit_three_month" style="width:8%">
                                <span slot="append">次</span>
                            </Input>
                            <span class="list_message">近6个月查询</span>
                            <Input v-model="condition.credit_six_month" style="width:8%">
                                <span slot="append">次</span>
                            </Input>
                            <span class="list_message">近12个月查询</span>
                            <Input v-model="condition.credit_twelve_month" style="width:8%">
                                <span slot="append">次</span>
                            </Input>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="overdue_credit_reference"><span>征信逾期</span></Checkbox>
                            <span class="list_message">是否允许当前逾期</span>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.credit_overdue">
                                    <Radio :label="0"><span>不允许</span></Radio>
                                    <Radio :label="1"><span>允许</span></Radio>
                                </RadioGroup>
                            </div>
                            <span class="list_message">逾期金额不超过</span>
                            <Input v-model="condition.credit_overdue_sum" style="width:20%">
                                <span slot="append">元</span>
                            </Input>
                        </div>
                        <div class="right_flex">
                            <Checkbox label="maximum_overdue_time"><span>最长逾期时间</span></Checkbox>
                            <span class="list_message">近半年不超过</span>
                            <Input v-model="condition.overdue_half_time" style="width:15%">
                                <span slot="append">天</span>
                            </Input>
                            <span class="list_message">近1年不超过</span>
                            <Input v-model="condition.overdue_one_time" style="width:15%">
                                <span slot="append">天</span>
                            </Input>
                            <span class="list_message">近2年不超过</span>
                            <Input v-model="condition.overdue_two_time" style="width:15%">
                                <span slot="append">天</span>
                            </Input>
                        </div>
                    </div>
                    <div class="list_flex">
                        <div class="flex_box">
                            <Checkbox label="overdue_times"><span>逾期次数</span></Checkbox>
                            <div class="flex_message">
                                <span class="list_message">近半年逾期不超</span>
                                <Input v-model="condition.overdue_quarter" style="width:80px">
                                    <span slot="append">次</span>
                                </Input>
                                <span class="list_message">近1年逾期不超</span>
                                <Input v-model="condition.overdue_half_year" style="width:80px">
                                    <span slot="append">次</span>
                                </Input>
                                <span class="list_message">近2年逾期不超</span>
                                <Input v-model="condition.overdue_year" style="width:80px">
                                    <span slot="append">次</span>
                                </Input>
                            </div>
                        </div>
                        <div>
                            <Checkbox label="credit_record"><span>征信记录</span></Checkbox>
                            <span class="list_message">白户是否准入</span>
                            <RadioGroup v-model="condition.admittance">
                                <Radio :label="1"><span>是</span></Radio>
                                <Radio :label="0"><span>否</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="liability_requirements"><span>负债要求</span></Checkbox>
                            <span class="list_message">总负债不超过</span>
                            <Input v-model="condition.liabilities" style="width:140px">
                                <span slot="append">元</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="identity_of_borrower"><span>借款人身份</span></Checkbox>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.identity">
                                    <Radio :label="1"><span>法人</span></Radio>
                                    <Radio :label="2"><span>法人或股东</span></Radio>
                                </RadioGroup>
                            </div>
                            <span class="list_message">股份占比</span>
                            <Input v-model="condition.stock_rate" style="width:140px">
                                <span slot="append">%以上</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="enterprise_time"><span>企业注册时间</span></Checkbox>
                            <span class="list_message">最低工商登记注册时间</span>
                            <Input v-model="condition.registration_time" style="width:140px">
                                <span slot="append">月以上</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="enterprise_type"><span>企业类型</span></Checkbox>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.company_type">
                                    <Radio :label="1"><span>小规模企业</span></Radio>
                                    <Radio :label="2"><span>一般纳税人</span></Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="continuous_running_money"><span>企业账户流动资金</span></Checkbox>
                            <span class="list_message">最低</span>
                            <Input v-model="condition.working_fund" style="width:180px">
                                <span slot="append">万元以上</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="continuous_account_running_money"><span>企业账户月经营流水</span></Checkbox>
                            <span class="list_message">最低</span>
                            <Input v-model="condition.running_water" style="width:180px">
                                <span slot="append">万元以上</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="continuous_running_time"><span>连续经营流水时长</span></Checkbox>
                            <span class="list_message">最低</span>
                            <Input v-model="condition.running_water_time" style="width:180px">
                                <span slot="append">个月</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="tax_payment"><span>企业纳税</span></Checkbox>
                            <span class="list_message">最低纳税总额</span>
                            <span class="list_message">最近1年</span>
                            <Input v-model="condition.ratal_year" style="width:140px">
                                <span slot="append">元</span>
                            </Input>
                            <span class="list_message">最近2年</span>
                            <Input v-model="condition.ratal_two_year" style="width:140px">
                                <span slot="append">元</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="continuous_taxes_time"><span>连续纳税时长</span></Checkbox>
                            <span class="list_message">近期连续纳税最低</span>
                            <Input v-model="condition.ratepaying_time" style="width:140px">
                                <span slot="append">个月</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="tax_declaration_requirements"><span>纳税0申报要求</span></Checkbox>
                            <span class="list_message">企业最近1年0申报次数不超过</span>
                            <Input v-model="condition.declaration_number" style="width:100px">
                                <span slot="append">次</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="average_invoice_billing"><span>企业月均开票金额</span></Checkbox>
                            <span class="list_message">最低开票金额</span>
                            <Input v-model="condition.min_invoice_sum" style="width:180px">
                                <span slot="append">元以上</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="one_year_billing_money"><span>企业近1年总开票金额</span></Checkbox>
                            <span class="list_message">最低开票总额</span>
                            <Input v-model="condition.min_invoice_total_sum" style="width:180px">
                                <span slot="append">元以上</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="continuous_billing_time"><span>企业近期连续开票时长</span></Checkbox>
                            <span class="list_message">最低</span>
                            <Input v-model="condition.min_invoice_duration" style="width:140px">
                                <span slot="append">个月以上</span>
                            </Input>
                        </div>
                        <div class="flex_box">
                            <Checkbox label="credit_rating_requirements"><span>企业纳税信用评级要求</span></Checkbox>
                            <div class="flex_box_radio">
                                <RadioGroup v-model="condition.credit_grade">
                                    <Radio label="A"><span>A级</span></Radio>
                                    <Radio label="AB"><span>AB级</span></Radio>
                                    <Radio label="ABC"><span>ABC级</span></Radio>
                                    <Radio label="ABCD"><span>ABCD级</span></Radio>
                                    <Radio label="ABCDM"><span>ABCDM级</span></Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="save_btn">
                            <div class="save_btn_color" @click="save">保存资料</div>
                        </div>
                    </div>
                </CheckboxGroup>
            </div>
        </div>
        <Modal
                v-model="uploadModal"
                title="上传资料"
                @on-cancel="() => {uploadModal = false}"
                @on-ok="fileOk">
            <addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif','doc','docx','pdf','mp3','mp4']"></addFile>
        </Modal>
    </div>
</template>

<script>
	import addFile from '../tool/addFile.vue';
    import TopBar from '../topbar/TopBar.vue'
    import dataCity from '../../assets/citydata.js'
    import {mapActions, mapGetters} from "vuex";
    import {saveProduct, getAllOrganization, getProduct} from '@/api/runSet'

    export default {
        name: "AddProduct",
		computed:{
			...mapGetters(['userInfo', 'token']),
		},
		created(){
            var id = this.$route.query.id || 0;
            this.id = id;
			this.loadData();
		},
        components: {
            TopBar, addFile
        },
        data() {
            return {
            	id: 0,
                uploadList: [],
                dataCity: dataCity,
                rigth_data_list: [],
                right_form: {
                    ext_info: {file: '', city: []},
                    organization_id: '0',
                    name: '',
                    product_number: '',
                    year_rate: '',
                    product_type: '0',
                    repayment_period: '',
                    min_loan_money: '',
                    max_loan_money: '',
                    bazaar_state: '0',
                    repayment_way: [],
                },
                condition: {
                    income: '',
                    min_income: '',
                    max_income: '',
                    house_location: '',
                    monthly_sum: '',
                    monthly_duration: '',
                    house_ID: '',
                    min_house_value: '',
                    max_house_age: '',
                    floor_space: '',
                    whole_house_ID: '',
                    land_deed: '',
                    house_value: '',
                    land_deed_floor_space: '',
                    receive_dividends: '',
                    plate_territory: [],
                    car_monthly_sum: '',
                    car_repayment_periods: '',
                    naked_car_sum: '',
                    car_age: '',
                    accumulation_fund: '',
                    accumulation_fund_time: '',
                    accumulation_fund_type: '',
                    social_security: '',
                    social_security_time: '',
                    social_security_type: '',
                    commercial_insurance_min_sum: '',
                    commercial_insurance_min_number: '',
                    policy_holder: '',
                    off_to_pay: '',
                    weilidai_sum: '',
                    weilidai_time: '',
                    zhima_number: '',
                    credit_one_month: '',
                    credit_two_month: '',
                    credit_three_month: '',
                    credit_six_month: '',
                    credit_twelve_month: '',
                    credit_overdue: '',
                    credit_overdue_sum: '',
                    overdue_half_time: '',
                    overdue_one_time: '',
                    overdue_two_time: '',
                    overdue_quarter: '',
                    overdue_half_year: '',
                    overdue_year: '',
                    admittance: '',
                    minAge: '',
                    maxAge: '',
                    min_entry_time: '',
                    liabilities: '',
                    identity: '',
                    stock_rate: '',
                    registration_time: '',
                    company_type: '',
                    working_fund: '',
                    running_water: '',
                    running_water_time: '',
                    ratal_year: '',
                    ratal_two_year: '',
                    ratepaying_time: '',
                    declaration_number: '',
                    min_invoice_sum: '',
                    min_invoice_total_sum: '',
                    min_invoice_duration: '',
                    credit_grade: ''
                },
                organizationList: [],
                product_type_list: [{
                    value: 1,
                    label: '个人信用贷'
                }],
                bazaar_state_list: [{
                    value: 1,
                    label: '正常'
                }],
				uploadModal: false
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
			async loadData() {
                let that = this;
                let data = {token: that.token};
                let res = await getAllOrganization(that, data);
                if (res.code == 1) {
                    that.organizationList = res.data.list;
                }
                if (this.id != 0) {
                    data = {token: that.token, id: this.id};
                    let res = await getProduct(that, data);
                    if (res.code == 1) {
                        that.right_form = res.data.item;
                        that.condition = res.data.item.ext_info.condition;
                        that.rigth_data_list = res.data.item.ext_info.check_list;
                    }
                }
			},
			uploadFile() {
				this.uploadModal = true
			},
			fileOk() {
				var that = this;
				that.right_form['ext_info']['file'] = that.$refs['addFile'].fileUrl;
				that.$refs['addFile'].clear();
			},
            save() {
                let that = this;
                this.throttle(async function() {
                    let data = {token: that.token};
                    data.data = that.right_form;
                    data.data.condition = that.condition;
                    data.data.check_list = that.rigth_data_list;
                    let res = await saveProduct(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        window.location = '/#/SectorSetup';
                    }
                }, 500)
            }
        }
    }
</script>

<style scoped lang="less">
    .ivu-checkbox-wrapper {
        width: 170px;
    }

    .right_che_flex {
        display: flex;
        flex-direction: column;

        div {
            font-weight: bold;
            color: #000000;
            margin: 2px 0;
        }
    }

    .right_title {
        font-weight: bold;
        color: #000000;
        font-size: 15px;
    }

    .save_btn {
        display: flex;
        justify-content: center;

        .save_btn_color {
            background-color: #21A0FF;
            width: 300px;
            color: #FFFFFF;
            text-align: center;
            height: 30px;
            line-height: 30px;
            margin-top: 50px;
            cursor: pointer;
        }

    }

    .flex_message {
        display: flex;
        align-items: center;
    }

    .add_product {
        background-color: #F7F8FB;
        width: 100%;
    }

    .left_content {
        width: 70%;
        min-width: 660px;
        background-color: #FFFFFF;
        padding: 20px;
        padding-top: 0;
    }

    .right_content {
        width: 70%;
        min-width: 951px;
        background-color: #FFFFFF;
        padding: 20px;
        padding-bottom: 0;

        .title {
            font-weight: bold;
            font-size: 18px;
            color: #000000;
            text-align: center;
            border-bottom: 1px solid #C6C6C6;
        }
    }

    .right_list {
        margin: 10px 0;
        display: flex;
        align-items: center;
    }

    .list_flex {
        display: flex;
        flex-direction: column;

        div {
            font-weight: bold;
            color: #000000;
            margin: 2px 0;
        }

        .flex_box {
            display: flex;
            align-items: center;
        }

        .list_message {
            font-weight: normal;
            color: #9F9F9F;
            margin: 0 10px;
        }
    }

    .list_message {
        font-weight: normal;
        color: #000000;
        margin: 0 10px;
    }

    .flex_box_radio div {
        font-weight: normal;
        color: #9F9F9F;
        display: flex;
        align-items: center;
    }

    .list_message_color {
        color: #9F9F9F;
    }

    .ivu-upload {
        display: flex;
        align-items: center;
    }

    .right_flex {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
</style>
